"use client"

import { Minus, Plus, Spinner } from "@medusajs/icons"
import type { CartPendingAction } from "../../context/cart-drawer-context"
import styles from "./cart-quantity-control.module.css"

export default function CartQuantityControl({
  value,
  max,
  disabled,
  pendingAction,
  onChange,
}: {
  value: number
  max: number
  disabled: boolean
  pendingAction: CartPendingAction["action"] | null
  onChange: (value: number, action: "decrease" | "select" | "increase") => void
}) {
  const options = Array.from({ length: Math.max(max, value, 1) }, (_, index) => index + 1)

  return (
    <div className={styles.quantity}>
      <button
        type="button"
        aria-label="Adedi azalt"
        disabled={disabled || value <= 1}
        onClick={() => onChange(value - 1, "decrease")}
      >
        {pendingAction === "decrease" ? <Spinner data-testid="quantity-decrease-spinner" /> : <Minus />}
      </button>
      <div className={styles.selectCell} data-pending={pendingAction === "select" ? "true" : undefined}>
        <select
          aria-label="Adet"
          value={value}
          disabled={disabled}
          data-pending={pendingAction === "select" ? "true" : undefined}
          onChange={(event) => onChange(Number(event.target.value), "select")}
        >
          {options.map((quantity) => <option key={quantity} value={quantity}>{quantity}</option>)}
        </select>
        <span className={styles.selectedValue} data-testid="quantity-selected-value" aria-hidden="true">
          {value}
        </span>
        {pendingAction === "select" ? (
          <span className={styles.selectSpinner} aria-hidden="true">
            <Spinner data-testid="quantity-select-spinner" />
          </span>
        ) : null}
      </div>
      <button
        type="button"
        aria-label="Adedi artır"
        disabled={disabled || value >= max}
        onClick={() => onChange(value + 1, "increase")}
      >
        {pendingAction === "increase" ? <Spinner data-testid="quantity-increase-spinner" /> : <Plus />}
      </button>
    </div>
  )
}
